import { useDropsList } from 'root/src/client/v2/_pages/drops/hooks/useDropsList';
import InfiniteScroll from 'react-infinite-scroller';
import { DROPS_INITIAL_PAGE } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { DropsListItemPlaceholder, } from 'root/src/client/v2/_pages/drops/components/DropsListItemPlaceholder';
import Link from 'next/link';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { memo } from 'react';
import { DropEventListContextProvider, } from 'root/src/client/v2/_pages/drops/contexts/dropEventList.context';
import { DropsListItem } from 'root/src/client/v2/_pages/drops/components/DropsListItem';
export const DropsList = memo(() => {
    var _a, _b;
    const { dropsQuery } = useDropsList();
    const data = (_b = (_a = dropsQuery === null || dropsQuery === void 0 ? void 0 : dropsQuery.data) === null || _a === void 0 ? void 0 : _a.pages.flatMap(result => result.items)) !== null && _b !== void 0 ? _b : [];
    return (
    // @ts-ignore
    <InfiniteScroll role="list" element="ul" className="flex flex-wrap justify-center p-0 sm:p-1 gap-6 sm:p-8" pageStart={DROPS_INITIAL_PAGE} loadMore={() => dropsQuery.fetchNextPage()} hasMore={dropsQuery.hasNextPage} loader={<DropsListItemPlaceholder key={0}/>}>
			{dropsQuery.isLoading && (<DropsListItemPlaceholder />)}
			{data.map(dropEvent => (<DropEventListContextProvider dropEvent={dropEvent} key={dropEvent.id}>
					<li>
						<Link href={routeUrls.drop(dropEvent.mnemonicId)} passHref>
							<a>
								<DropsListItem />
							</a>
						</Link>
					</li>
				</DropEventListContextProvider>))}
		</InfiniteScroll>);
}, () => true);
